import React, { useContext, useEffect, useRef, useState } from 'react';
import { CountriesData } from '../../widgets/STW/utility';
import { STWContext } from '../../widgets/STW/context';

const CountriesDropDown: React.FC<{
  onListItemClickHandle: (code: string, dial: string, code3: string) => void;
  closeDropdown: () => void;
}> = ({ onListItemClickHandle, closeDropdown }) => {
  const { preview } = useContext(STWContext);
  const [currentStyle, setCurrentStyle] = useState<any>(null);
  const wrapperRef = useRef(null);

  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      closeDropdown();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const importStyles = async () => {
      let stylesModule;
      if (!preview) {
        stylesModule = await import('./countriesDropdown.module.css');
      }
      setCurrentStyle(stylesModule.default);
    };
    importStyles().then();
  }, [preview]);

  if (!currentStyle) {
    return <></>;
  }

  return (
    <>
      <div
        ref={wrapperRef}
        id={currentStyle.bikStwMandWaDropdown}
        className={currentStyle.dropdownContent}
        style={{ overflowX: 'hidden', overflowY: 'auto' }}
      >
        <div>
          {CountriesData.map(data => {
            const flag = `https://flagcdn.com/${data.code.toLowerCase()}.svg`;
            const code = data.dial;
            return (
              <div
                key={data.dial}
                onClick={() => {
                  onListItemClickHandle(data.code, data.dial, data.code3);
                }}
              >
                <div className={currentStyle.bikDropDownItem}>
                  <img
                    className={currentStyle.bikStwCountryFlag}
                    src={`${flag}`}
                  />
                  <h2 className={currentStyle.bikStwH2}>{code}</h2>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
export default CountriesDropDown;
